import styled from "styled-components";

export default styled.div`
  margin-top: 1.5rem;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
  table {
    border: none;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.ellipse_15};
    color: ${({ theme }) => theme.colors.ellipse_16};
    font-weight: 500;
    font-size: 13px;
    thead {
      height: 40px;
      background-color: ${({ theme }) => theme.colors.ellipse_14};
      color: rgba(109, 125, 151, 1);
      font-style: normal;
      line-height: 15px;
      th {
        font-weight: 400 !important;
      }
    }
    tr {
      th,
      td {
        text-align: start;
      }
    }
    .text-center {
      text-align: center;
    }
    thead tr th:first-child,
    tbody tr td:first-child {
      padding-inline-start: 2rem;
    }
    tbody tr {
      height: 40px;
    }
    .boosting-percentage__APR {
      display: flex;
      align-items: center;
      gap: 7px;
    }
  }
  .pagination-input {
    border: 0;
    padding: 0 !important;
    padding-inline-start: 0.5rem !important;
    width: 30px;
    height: 30px;
    background-color: transparent !important;

    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    [type="number"] {
      -moz-appearance: textfield;
    }
  }
  @media screen and (max-width: 769px) {
    display: none;
  }
`;

export const DataStyle = styled.div`
  display: none;
  margin-top: 1.5rem;
  @media screen and (max-width: 769px) {
    display: flex;
    flex-direction: column;
    gap: 2px;
    .data-table-row {
      display: flex;
      flex-direction: column;
      gap: 2px;
      .header,
      .values {
        padding: 7px;
        display: flex;
        justify-content: space-between;
        > * {
          align-self: center;
          flex: 1;
          word-break: break-word;
          margin: 0;
          font-size: 9px;
          padding: 0 1px;
        }
      }
      .header {
        background-color: ${({ theme }) => theme.colors.ellipse_14};
        color: rgba(109, 125, 151, 1);

        * {
          font-size: 10px;
        }
      }
      .values {
        background-color: ${({ theme }) => theme.colors.ellipse_15};
        color: ${({ theme }) => theme.colors.ellipse_16};
      }
      .more-information {
        width: fit-content;
        cursor: pointer;
        > * {
          color: #6d7d97;
        }
        display: flex;
        align-items: center;
        padding-inline-start: 1rem;
        gap: 0.3rem;
        font-size: 9px;
        svg {
          width: 8px;
        }
      }

      .data-table-row-oppend {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 5px;
        > div {
          display: flex;
          gap: 1rem;
          justify-content: center;
          font-size: 12px;
          .key {
            align-self: center;
            text-align: right;
            color: #6d7d97;
          }
          > * {
            color: ${({ theme }) => theme.colors.ellipse_1};
            margin: 0;
            flex: 1;
          }
        }
      }
    }
    .boosting-percentage__APR {
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }
`;

const statusStylesTable = {
  Claimed: `
    background-color: rgba(111, 213, 139, 0.3);
    color: #6FD58B;
  `,
  Locked: `
    background-color: rgba(241, 53, 78, 0.3);
    color: #F1354E;
  `,
  Unlocked: `
    background-color: rgba(250, 192, 105, 0.3);
    color: #FAC069;
  `,
};

export const StatusStyleTable = styled.div`
  margin: 0;
  display: grid;
  place-items: center;
  padding: 2px;
  font-weight: 600;
  box-shadow: 0px 16px 26.4px rgba(102, 90, 136, 0.08);
  border-radius: 3px;

  font-style: normal;
  font-weight: 600;
  font-size: 8.6px;
  line-height: 14px;
  ${({ status }) => statusStylesTable[status]};
`;

export const PaginationStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 1rem;
  margin: 1rem 0;

  .rows-per-page-container {
    display: flex;
    align-items: center;
    color: rgba(110, 126, 152, 1);
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 18px;
  }

  #rows-per-page {
    cursor: pointer;
    background-color: transparent;
    color: #6e7e98;
    border: 0;
    width: 50px;
    padding: 0 5px;
    :focus {
      outline: none;
    }
  }

  .previous,
  .next {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    cursor: pointer;
    display: grid;
    place-items: center;
    background-color: #58709e;
    i {
      color: #58709e;
      font-size: 14px;
    }
  }

  .pages-count {
    display: flex;
    align-items: center;
    gap: 1rem;
    ul {
      margin: 0;
      list-style: none;
      display: flex;
      align-items: center;
      gap: 5px;
      li {
        user-select: none;
        display: grid;
        place-items: center;
        width: 30px;
        height: 30px;
        border-radius: 8px;
        cursor: pointer;
        background: rgba(88, 112, 158, 0.15);
        color: #58709e;
        &.active {
          background: unset;
          border: 0.957672px solid #58709e;
          transition: all 0.3s ease-in-out;
        }
        &:hover {
          background: unset;
          border: 0.957672px solid #58709e;
          transition: all 0.3s ease-in-out;
        }
      }
    }
    .disabled, .active {
      pointer-events: none;
    }
  }
  @media screen and (max-width: 769px) {
    .pages-count {
      gap: 0.5rem;
    }
    ul li,
    .previous,
    .next {
      border-radius: 6px;
      width: 25px;
      height: 25px;
    }
  }
`;
